import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-16 px-6 max-w-3xl mx-auto" data-id="element-163">
      <FadeIn data-id="element-164">
        <h2 className="text-3xl sm:text-4xl text-center text-taupe mb-8" data-id="element-165">
          El verdadero problema
        </h2>

        <p className="text-lg text-taupe/80 mb-8 leading-relaxed" data-id="element-166">
          La mayoría de los consejos de sueño te dicen dos cosas: o dejas que tu
          bebé llore hasta que se rinda, o te resignas a no dormir en tres años.
          Ninguna de las dos opciones es sostenible.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-167">
        <div className="bg-white rounded-2xl shadow-sm border border-sage/20 p-6 sm:p-8 relative overflow-hidden" data-id="element-168">
          <div className="absolute top-0 left-0 w-2 h-full bg-amber" data-id="element-169"></div>
          <p className="text-lg text-taupe/80 leading-relaxed mb-4" data-id="element-170">
            El verdadero problema no es que tu bebé "no sepa dormir". El
            problema es el{' '}
            <strong className="text-amber font-bold bg-amber/10 px-2 py-1 rounded" data-id="element-171">
              Sobrecansancio Químico
            </strong>
            .
          </p>
          <p className="text-lg text-taupe/80 leading-relaxed" data-id="element-172">
            Cuando pasas la ventana de sueño de tu hijo por solo 10 minutos, su
            cuerpo libera cortisol y adrenalina. En ese momento, estás
            intentando dormir a un bebé que, químicamente, está en estado de
            alerta máxima.
          </p>
        </div>
      </FadeIn>
    </section>;
}